import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import React, { Component } from 'react';
import { showError, showInfo } from '../../../actions/notificationActions';

import { callApi } from '../../../utils';
import { closeAllModals } from '../../../actions/modalActions';
import { connect } from 'react-redux';

export default connect((state) => ({
  open: state.modals.broadcastNotification,
  id: state.modals.data,
}))(
  class BroadcastNotificationModal extends Component {
    state = {
      loading: false,
      error: '',
      title: '',
      message: '',
    };

    componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open && this.props.open) {
        this.setState({
          loading: false,
          error: '',
          title: '',
          message: '',
        });
      }
    }

    broadCastNotification = async () => {
      if (!this.state.title || !this.state.message) {
        this.setState({ error: 'Title and message are required' });
        return;
      }
      this.setState({ loading: true });
      try {
        const res = await callApi(
          `/campaigns/${this.props.id}/broadcast`,
          {
            title: this.state.title,
            message: this.state.message,
          },
          'post'
        );
        this.setState({ loading: false });
        this.props.dispatch(
          showInfo(res.message || 'Notification broadcasted')
        );
        this.setState({ title: '', message: '' });
        this.props.dispatch(closeAllModals());
        // this.props.refresh();
      } catch (error) {
        this.props.dispatch(showError(error));
        this.setState({ loading: false });
      }
    };

    close = () => {
      this.props.dispatch(closeAllModals());
    };

    setInput = (e) => {
      const { name, value } = e.target;
      this.setState({ [name]: value });
      this.setState({ error: '' });
    };

    render() {
      const open = this.props.open;
      return (
        <div>
          <Modal size="lg" isOpen={open} toggle={this.close}>
            <ModalHeader toggle={this.close}>
              Broadcast Notification
            </ModalHeader>
            <ModalBody>
              <form>
                <div>
                  <FormGroup>
                    <Label className="mt-3">Title:</Label>
                    <Input
                      name="title"
                      type="text"
                      onChange={this.setInput}
                      value={this.state.title}
                      disabled={this.state.loading}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="message">Message</Label>
                    <Input
                      onChange={this.setInput}
                      id="message"
                      value={this.state.message}
                      name="message"
                      type="textarea"
                      disabled={this.state.loading}
                    />
                  </FormGroup>
                </div>
                <div />
              </form>
              {this.state.error ? (
                <span style={{ color: 'red' }}>{this.state.error}</span>
              ) : (
                ''
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                color="success"
                disabled={this.state.loading}
                onClick={this.broadCastNotification}
              >
                Broadcast Notification{' '}
                {this.state.loading ? (
                  <span className="fas fa-spinner fa-spin"></span>
                ) : (
                  ''
                )}
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }
  }
);
